import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useLanguage } from '../../contexts/LanguageContext';
import { useInterfacePreference } from '../../hooks/useInterfacePreference';
import './InterfaceChooser.css';

function InterfaceChooser({ onDismiss }) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { localizedPath } = useLanguage();
  const { setPreference } = useInterfacePreference();

  const handleBasic = () => {
    setPreference('basic');
    onDismiss();
  };

  const handlePro = () => {
    setPreference('pro');
    onDismiss();
    navigate(localizedPath('/terminal'));
  };

  const handleSkip = () => {
    onDismiss();
  };

  return (
    <div className="version-overlay">
      <div className="version-modal">
        <div className="version-modal-logo">[ TRADERMAP.IO ]</div>
        <h2 className="version-modal-title">
          {t('interfaceChooser.title', 'Choose your interface')}
        </h2>
        <div className="version-modal-subtitle">
          {t('interfaceChooser.subtitle', 'SAME DATA \u00B7 DIFFERENT EXPERIENCE \u00B7 SAVED AUTOMATICALLY')}
        </div>

        <div className="version-cards">
          {/* Basic Card */}
          <div className="version-card version-card--basic" onClick={handleBasic}>
            <span className="version-card-badge version-card-badge--standard">
              {t('interfaceChooser.basicBadge', 'STANDARD')}
            </span>
            <div className="version-card-name">
              {t('interfaceChooser.basicName', 'Basic')}
            </div>
            <ul className="version-card-features">
              <li>{t('interfaceChooser.basicF1', 'Card-based layout')}</li>
              <li>{t('interfaceChooser.basicF2', 'Rounded UI')}</li>
              <li>{t('interfaceChooser.basicF3', 'Color-rich design')}</li>
              <li>{t('interfaceChooser.basicF4', 'Simplified data view')}</li>
              <li>{t('interfaceChooser.basicF5', 'Mobile-first')}</li>
            </ul>
            <button className="version-card-btn version-card-btn--basic" onClick={(e) => { e.stopPropagation(); handleBasic(); }}>
              {t('interfaceChooser.basicBtn', 'Use Basic')}
            </button>
          </div>

          {/* Pro Card */}
          <div className="version-card version-card--pro" onClick={handlePro}>
            <span className="version-card-badge version-card-badge--terminal">
              {t('interfaceChooser.proBadge', 'TERMINAL')}
            </span>
            <div className="version-card-name">
              {t('interfaceChooser.proName', 'Professional')}
            </div>
            <ul className="version-card-features">
              <li>{t('interfaceChooser.proF1', 'Terminal-style layout')}</li>
              <li>{t('interfaceChooser.proF2', 'Maximum data density')}</li>
              <li>{t('interfaceChooser.proF3', 'Monospace typography')}</li>
              <li>{t('interfaceChooser.proF4', 'Multi-panel grid')}</li>
              <li>{t('interfaceChooser.proF5', 'Mega whale alerts')}</li>
            </ul>
            <button className="version-card-btn version-card-btn--pro" onClick={(e) => { e.stopPropagation(); handlePro(); }}>
              {t('interfaceChooser.proBtn', 'Launch Terminal \u2192')}
            </button>
          </div>
        </div>

        <button className="version-skip" onClick={handleSkip}>
          {t('interfaceChooser.skip', 'SKIP \u2014 DECIDE LATER')}
        </button>
      </div>
    </div>
  );
}

export default InterfaceChooser;
